import { SET_X_TRACE_ID } from 'client/actions/constants';

/**
 * Updates the request trace ID while preserving the other x-header values.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export function xHeadersReducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_X_TRACE_ID:
      return {
        ...state,
        'x-trace-id': action.xTraceId,
      };
    default:
      return state;
  }
}
